export enum IssueCloseManagementType {
    ReCalculate = 1,
    Issue = 2,
    Both = 3,
}
